<template>
  <f7-page login-screen>
    <navbar></navbar>
    <f7-block style="margin-top: -50px; margin-bottom: -75px;">
      <lottie
        :options="defaultOptionsDone"
        :height="300"
        :width="300"
        v-on:animCreated="handleAnimation"
      />
    </f7-block>
    <f7-block class="text-align-center">
      <h4>{{ 'auth.forgot_success_page' | translate}} :)</h4>
      <span>{{ 'auth.forgot_success_page_description' | translate}}</span>
    </f7-block>
    <f7-block class="text-align-center">
      <f7-button @click="onBackToLogin" raised>{{ 'auth.back_login' | translate}}</f7-button>
    </f7-block>
  </f7-page>
</template>

<script>
import * as animationDataDone from "@/assets/lottie/done.json";
import Lottie from "vue-lottie";
import Navbar from "@/components/Navbar/Navbar.vue";

export default {
  components: {
    lottie: Lottie,
    Navbar
  },
  data: () => {
    return {
      defaultOptionsDone: {
        animationData: animationDataDone.default,
        loop: false
      }
    };
  },
  methods: {
    onBackToLogin() {
      this.$f7router.navigate("/login/");
    },
    handleAnimation(anim) {
      this.anim = anim;
    }
  }
};
</script>